<template>
  <lazy-component>
    <div class="wrapper">
      <iframe
        width="500"
        height="479"
        :src="src"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  </lazy-component>
</template>

<script>
export default {
  name: "app-imgur",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    src() {
      return `https://imgur.com/${this.id}/embed?pub=true`;
    }
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
